/** Voice picker — 10 presets, default Yinzer. Rendered as a styled native select. */
import { VOICE_KEYS, VOICES } from '@pghbites/shared';

interface VoicePickerProps {
  value: string;
  onChange: (voice: string) => void;
}

export function VoicePicker({ value, onChange }: VoicePickerProps) {
  return (
    <label className="field" htmlFor="voice">
      <span className="field-label">🎙️ Voice</span>
      <select
        id="voice"
        className="field-input voice-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {VOICE_KEYS.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
      <span className="field-hint">{VOICES[value]}</span>
    </label>
  );
}
